import React, { useState, useEffect, useRef } from 'react';
import './CustomSearch4.scss';

const CustomSearch4 = ({
                           name,
                           data = [],
                           onSelect = () => {},
                           placeholder = "",
                           className = "",
                           initialValue = "",
                           showSelectedCount = false,
                           selectedIds = [],
                           allowClear = false,
                           disabled = false,
                           multiple = false,
                           searchable = false,
                           value = undefined
                       }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState(() => {
        if (value !== undefined) return value;
        if (initialValue) return initialValue;
        return '';
    });
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (value !== undefined && value !== filter) {
            setFilter(value);
            if (value === '') {
                setIsOpen(false);
            }
        }
    }, [value]);

    const handleFilterChange = (event) => {
        const newValue = event.target.value;
        setFilter(newValue);
        if (!isOpen && newValue.trim() !== '') {
            setIsOpen(true);
        }
        setHighlightedIndex(-1);
    };

    const handleItemSelect = (item) => {
        if (!item) return;

        const itemId = item.guid || item.id || item.value;
        const itemName = item.name || item.fio || item.full_name || 'Неизвестно';

        if (typeof onSelect === 'function') {
            onSelect({
                id: itemId,
                name: itemName,
                value: item.value,
                originalData: item
            });
        }

        if (!multiple) {
            setFilter(itemName);
            setIsOpen(false);
        } else {
            setFilter('');
        }
        inputRef.current?.focus();
    };

    const handleInputClick = () => {
        if (!disabled) {
            setIsOpen(true);
            setHighlightedIndex(-1);
        }
    };

    const handleKeyDown = (e) => {
        if (!isOpen) {
            if (e.key === 'Enter' || e.key === 'ArrowDown') {
                e.preventDefault();
                setIsOpen(true);
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setHighlightedIndex(prev =>
                    prev < filteredData.length - 1 ? prev + 1 : 0
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setHighlightedIndex(prev =>
                    prev > 0 ? prev - 1 : filteredData.length - 1
                );
                break;
            case 'Enter':
                e.preventDefault();
                if (highlightedIndex >= 0 && filteredData[highlightedIndex]) {
                    handleItemSelect(filteredData[highlightedIndex]);
                } else if (filteredData.length === 1) {
                    handleItemSelect(filteredData[0]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setIsOpen(false);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredData = Array.isArray(data)
        ? data.filter(item => {
            if (!item || typeof item !== 'object') return false;

            const displayValue = item.name || item.fio || item.full_name || '';

            if (!searchable || filter.trim() === '') {
                return true;
            }

            return displayValue.toLowerCase().includes(filter.toLowerCase());
        })
        : [];

    const isItemSelected = (itemId) => {
        return selectedIds.includes(itemId);
    };

    return (
        <div className={`custom_search4_wrapper ${className}`} ref={dropdownRef}>
            <div className="custom_search4_dropdown_container">
                <input
                    ref={inputRef}
                    type="text"
                    placeholder={placeholder || name}
                    value={filter}
                    onChange={handleFilterChange}
                    onClick={handleInputClick}
                    onKeyDown={handleKeyDown}
                    className="custom_search4_input"
                    disabled={disabled}
                    autoComplete="off"
                    readOnly={!searchable}
                />

                {isOpen && (
                    <div className={`custom_search4_dropdown_wrapper ${filteredData.length === 1 ? 'custom_search4_single_item' : ''}`}>
                        <div className="custom_search4_dropdown_content">
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => {
                                    const displayValue = item.name || item.fio || item.full_name || 'Неизвестно';
                                    const itemId = item.guid || item.id || item.value;
                                    const isSelected = isItemSelected(itemId);
                                    const isHighlighted = highlightedIndex === index;

                                    return (
                                        <div
                                            key={itemId ? `${itemId}-${index}` : index}
                                            onClick={() => handleItemSelect(item)}
                                            className={`custom_search4_dropdown_item ${
                                                isHighlighted ? 'custom_search4_highlighted' : ''
                                            } ${isSelected ? 'custom_search4_selected' : ''}`}
                                            onMouseEnter={() => setHighlightedIndex(index)}
                                            onMouseLeave={() => setHighlightedIndex(-1)}
                                        >
                                            <span className="custom_search4_item_name">{displayValue}</span>
                                            {isSelected && <span className="custom_search4_selected_indicator">✓</span>}
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="custom_search4_dropdown_item custom_search4_no_results">
                                    {searchable && filter.trim() ? 'Совпадений не найдено' : 'Нет доступных данных'}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomSearch4;